import { useState } from 'react'

import { useContext } from '@/utils/contextUtils'

import { SessionContext } from './context'
import { ISession, ISessionContext } from './types'

export function useProvideSession(initialValue: ISession): ISessionContext {
  const [session, setSession] = useState<ISession>(initialValue)

  function setEmailCampaign(
    emailCampaign: string | undefined | null,
    ltpEmailCampaign: string | undefined | null
  ): void {
    const emailsData: Record<string, string> = {}

    if (emailCampaign) {
      emailsData['utm_email_campaign'] = emailCampaign
    }

    if (ltpEmailCampaign) {
      emailsData['utm_ltp_email_campaign'] = ltpEmailCampaign
    }

    setSession({
      ...session,
      utmParams: {
        ...session.utmParams,
        ...emailsData,
      },
    })
  }

  return {
    ...session,
    setEmailCampaign,
  }
}

export function useSession(): ISessionContext {
  return useContext<ISessionContext>(SessionContext)
}
